<template>
    <div class="modal-body">
        <form class="mb-4">
            <div class="input-group input-group-merge">
                <input type="search" v-model="search" class="form-control form-control-prepended" placeholder="Tìm theo tỉnh, thành phố">
                <div class="input-group-prepend">
                    <div class="input-group-text">
                        <span class="fe fe-search"></span>
                    </div>
                </div>
            </div>
        </form>

        <div class="my-n3">
            <div class="list-group list-group-flush" v-if="regions.length > 0">
                <a v-for="region in filteredRegions" :href="$root.url('orn_web_cinema_region', { slug : region.slug })" class="list-group-item d-flex justify-content-between align-items-center px-0" v-on:click.prevent="doChangeRegion(region, $event)">
                    <h4 class="text-body mb-0">
                        {{ region.name }}
                        <span class="small text-muted d-block mt-1">
                            {{ region.total_cinemas }} {{ $root.translate('label.num_of_cinemas') }}
                        </span>
                    </h4>
                    <span class="text-danger" v-if="isSelectedRegion(region)"><i class="fe fe-check-circle"></i></span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'Regions',
        data() {
            return {
                search: '',
                regions: [],
                errors: []
            }
        },
        created() {
            let baseUri = process.env.MOVEEK_API_ENDPOINT;
            axios.get(baseUri + '/v1/regions?order[priority]=ASC')
                .then(response => {
                    this.regions = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                });
        },
        computed: {
            filteredRegions() {
                if (this.search === '') return this.regions
                return this.regions.filter(region => {
                    return region.name.toLowerCase().includes(this.search.toLowerCase())
                        || (region.alias && region.alias.toLowerCase().includes(this.search.toLowerCase()))
                })
            }
        },
        methods: {
            isSelectedRegion: function(region) {
                if (this.$root.getRegion() === region.id) {
                    return true;
                }
                return false;
            },
            doChangeRegion: function(region) {
                let modal = document.getElementById('locationModalTrigger').Modal;
                if (this.$root.getRegion() !== region.id) {
                    this.$root.setRegion(region.id);
                    // @TODO implement bootstrap dialog: https://gitlab.com/vuphuong87/moveek/-/issues/83
                    this.$root.loading();
                    window.location = this.$root.url('orn_web_cinema_region', { slug : region.slug });
                    modal.hide();
                }
                else {
                    modal.hide();
                }
            }
        }
    }
</script>

<style scoped>
</style>